import loadConfiguration from './configuration';

// Mapper of frontshop env variables to DashboardUI ones
export function getConfiguration() {
    const {
        APP_CONFIG,
        CONTENTFUL_SPACE_ID,
        CONTENTFUL_DELIVERY_ACCESS_TOKEN,
        SEGMENT_WRITE_KEY,
    } = loadConfiguration();

    return {
        apiBaseUrl: APP_CONFIG.apiUrl,
        graphqlGatewayApi: APP_CONFIG.graphQLv2,
        // Leaving the app id and the module so dashboard can work
        // We will create a cleanup task after dixa migration completed
        intercomAppId: APP_CONFIG.intercomAppId,
        flagrBaseUrl: APP_CONFIG.flagr,
        segmentWriteKey: SEGMENT_WRITE_KEY,
        contentfulSpaceId: CONTENTFUL_SPACE_ID,
        contentfulAccessToken: CONTENTFUL_DELIVERY_ACCESS_TOKEN,
        hostBaseUrl: '',
    };
}
